// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".synchro p{padding:0;margin:10px 0}.synchro p:first-child{font-size:14px;color:#006dcc}.synchro p:nth-child(2){color:#666}.synchro .el-input{width:360px}.synchro .el-form-item__label{font-size:14px;width:153px;text-align:left}.synchro .el-form-item__error{left:153px}", ""]);
// Exports
module.exports = exports;
